import React, {SyntheticEvent} from 'react';
import ModalV4 from '../../../app/ui/modal/v4/v4';
import ItemViewTop from "../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../error-boundary";
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5-new";
import VScroll from "../../gd-components/scrolling/custom-v-scroll/v-scroll";
import FieldFormElement from "../../../core/fields3/render/form-elemnent";
import AttendanceFields from "../../model2/attendance-event/fields";
import AttendanceEvent from "../../model2/attendance-event/attendance-event";
import FormModel from "../../gd-form/common/form-model-manager";
import FormFieldError from "../../gd-form/common/form-error/form-field-error";
import FormRowFlex from "../../gd-form/form/form-flex/row";
import FormFlex from "../../gd-form/form/form-flex/form";
import {AttendanceType} from "../../model2/attendance-event/const";
import AppMyAttendance from "../../../views/attendance/app";

type Props = {
    params: {
        app: AppMyAttendance
    }
}

export default class ModalAddAttendance extends ModalV4 {

    public clockInForm          : FormModel
    public clockOutForm         : FormModel

    public fields               : AttendanceFields  = new AttendanceFields()

    public clockInEvent         : AttendanceEvent
    public clockOutEvent        : AttendanceEvent

    constructor(props: Props) {
        super(props);

        this.clockInEvent = new AttendanceEvent({
            date            : props.params.app.curDate.format("YYYY-MM-DD"),
            createdByUserId : gd.viewFor.userId,
            type            : AttendanceType.CLOCKED_IN,
            timestamp       : props.params.app.curDate
        })

        this.clockOutEvent = new AttendanceEvent({
            date            : props.params.app.curDate.format("YYYY-MM-DD"),
            createdByUserId : gd.viewFor.userId,
            type            : AttendanceType.CLOCKED_OUT,
            timestamp       : props.params.app.curDate
        })

        this.clockInForm    = new FormModel(this.clockInEvent,{
            onSubmit: this.clockInFormSubmit
        })
        this.clockOutForm   = new FormModel(this.clockOutEvent,{
            onSubmit: this.clockOutFormSubmit
        })

        this.clockInForm.onFieldChanged(gd.fields.attendance.date.fieldId, (value: Moment)=>{
            this.clockOutEvent.date = value
        } )
    }

    onClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    clockInFormSubmit = (clockInFormValues: any)=>{
        this.clockOutForm.onSubmitClick.call(this.clockOutForm, clockInFormValues)
    }

    clockOutFormSubmit = (clockOutFormValues: any, clockInFormValues: any)=>{
        this.props.params.onSubmit(clockInFormValues, clockOutFormValues, this.clockInForm)
    }

    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">Clock In/Out</div>

        return (
            <div className="v4-container placement-middle ui5-iv" style={{width: 840, height: 700}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <div className="iv-left-column iv-column">
                    <div className="details-big-icon">
                        <div className="isvg isvg-clock-in-out"/>
                    </div>
                </div>
                <ErrorBoundary>
                    <div className="iv-content with-left-panel">
                        <VScroll>
                            <div className="p-l-30">
                                <FormFlex className="m-t-40  m-l-20">
                                    <FormRowFlex width={150} label="Report date" field={this.fields.date} form={this.clockInForm}>
                                        <FieldFormElement form={this.clockInForm}
                                                          field={this.fields.date}
                                                          model={this.clockInEvent}
                                                          className="w-300"/>
                                        <FormFieldError form={this.clockInForm} field={this.fields.date} className="w-300"/>
                                    </FormRowFlex>
                                    <FormRowFlex width={150} label="User" field={this.fields.createdByUserId} form={this.clockInForm}>
                                        <FieldFormElement form={this.clockInForm}
                                                          field={this.fields.createdByUserId}
                                                          model={this.clockInEvent}
                                                          className="w-300"/>
                                        <FormFieldError form={this.clockInForm} field={this.fields.createdByUserId}/>
                                    </FormRowFlex>

                                    <div className="ui5-title-app-name max-w-350 m-t-20 m-b-30">Clock In</div>

                                    <FormRowFlex width={150} label="Time" field={this.fields.timestamp} form={this.clockInForm}>
                                        <div className="flex-row-left-center h-36 ui5-txt-default">
                                            <FieldFormElement form={this.clockInForm}
                                                              field={this.fields.timestamp}
                                                              model={this.clockInEvent}
                                                              className="w-300"/>
                                            <FormFieldError form={this.clockInForm} field={this.fields.timestamp} className="w-200"/>
                                        </div>
                                    </FormRowFlex>

                                    <FormRowFlex width={150} label="Location" field={this.fields.officeId} form={this.clockInForm}>
                                        <FieldFormElement form={this.clockInForm}
                                                          field={this.fields.officeId}
                                                          model={this.clockInEvent}
                                                          className="w-300"/>
                                        <FormFieldError form={this.clockInForm} field={this.fields.officeId} className="w-200"/>
                                    </FormRowFlex>
                                    <FormRowFlex width={150} label="Comment" field={this.fields.comment} form={this.clockInForm}>
                                        <FieldFormElement form={this.clockInForm}
                                                          field={this.fields.comment}
                                                          model={this.clockInEvent}
                                                          className="w-300"/>
                                    </FormRowFlex>


                                    <div className="ui5-title-app-name max-w-350 m-t-20 m-b-30">Clock Out</div>

                                    <FormRowFlex width={150} label="Time" field={this.fields.timestamp} form={this.clockOutForm}>
                                        <FieldFormElement form={this.clockOutForm}
                                                          field={this.fields.timestamp}
                                                          model={this.clockOutEvent}
                                                          className="w-300"/>
                                        <FormFieldError form={this.clockOutForm} field={this.fields.timestamp} className="w-200"/>
                                    </FormRowFlex>

                                    <FormRowFlex width={150} label="Comment" field={this.fields.comment} form={this.clockOutForm}>
                                        <FieldFormElement form={this.clockOutForm}
                                                          field={this.fields.comment}
                                                          model={this.clockOutEvent}
                                                          className="w-300"/>
                                    </FormRowFlex>

                                    <FormRowFlex width={150} label="">
                                        <ButtonSubmit form={this.clockInForm} className="submit w-100" label="Submit"/>
                                    </FormRowFlex>
                                </FormFlex>
                            </div>
                        </VScroll>
                    </div>
                </ErrorBoundary>
            </div>
        )
    }
}
